import { Button, CircularProgress } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import React, { ReactElement } from 'react';
 
interface ButtonWithLoadingFeedbackProps extends ButtonProps {
    isLoading: boolean;
    LoadingFeedback?: ReactElement;
}

const ButtonWithLoadingFeedback: React.FC<ButtonWithLoadingFeedbackProps> = ({
    isLoading,
    LoadingFeedback = <CircularProgress style={{ color: 'white' }} size={22} />,
    type,
    children,
    ...props
}) => {
    type = type??'submit'
    return (
        <Button disabled={isLoading} type={type} variant="contained" color="primary" size="small" {...props}>
            {/* {isLoading ? <CircularProgress style={{ color: 'white' }} size={22} /> : 'Opslaan'} */}
            {isLoading ? LoadingFeedback : children}
        </Button>
    );
};

export default ButtonWithLoadingFeedback; 
